import React, { useState, useEffect } from 'react';
import Header from '../../dashboard/header';
import { Link } from 'react-router-dom';
import { Table, Modal, Button } from 'react-bootstrap';
import { FaPlus, FaCheck, FaEdit, FaTrash, FaSortAmountUp, FaSortAmountDown, FaArrowLeft, FaArrowRight, } from 'react-icons/fa';
import Navbar from '../../dashboard/navbar';
import { useLocation, useNavigate } from 'react-router-dom';
import Sidebar from '../../dashboard/sidebar';
import useAuth from '../../dashboard/useAuth';
import axios from 'axios';

const Liste_diffusion = ({ titre }) => {
    useAuth()

    const [diffusions, setDiffusions] = useState([]);
    const [selectedDiffusion, setSelectedDiffusion] = useState(null);
    const [expandedDescriptions, setExpandedDescriptions] = useState({});
    const [sortConfig, setSortConfig] = useState({ key: 'id', direction: 'ascending' });
    const [searchTerm, setSearchTerm] = useState('');
    const [showModal, setShowModal] = useState(false);
    const [showDeleteModal, setShowDeleteModal] = useState(false);
    const [isLoading, setIsLoading] = useState(false); // Pour gérer le loader
    const [alert, setAlert] = useState({ message: '', type: '' });
    const [expandedDiffusionIds, setExpandedDiffusionIds] = useState([]);
    const [diffusionDescriptionOverflows, setDiffusionDescriptionOverflows] = useState({});


    // Pagination state
    const [currentPage, setCurrentPage] = useState(1);
    const [itemsPerPage, setItemsPerPage] = useState(10); // Nombre d'éléments par page
    const totalItems = diffusions.length;  // Si 'formationList' contient toutes les formations

    const location = useLocation();
    const queryParams = new URLSearchParams(location.search);

    const user_id = localStorage.getItem('user_id');
    const navigate = useNavigate();

    // Utilisation de useEffect pour mettre à jour le titre de la page
    useEffect(() => {
        if (user_id) {
            document.title = "eTrainApp | Liste de Diffusion"; // Définit le titre de la page
        }
    }, [user_id]);

    const fetchDiffusions = async () => {
        try {
            const response = await fetch(process.env.REACT_APP_HOTE + '/liste-diffusion/');
            if (response.ok) {
                const data = await response.json();
                setDiffusions(data);
            } else {
                console.error('Erreur lors de la récupération des listes de diffusion');
            }
        } catch (error) {
            console.error('Erreur réseau:', error);
        }
    };



    useEffect(() => {

        fetchDiffusions();
    }, []);

    const showAlert = (message, type = 'success') => {
        setAlert({ message, type });
        setTimeout(() => {
            setAlert({ message: '', type: '' });
            fetchDiffusions();
        }, 3000);
    };

    const handleRowClick = (listediffusion_id) => {
        setSelectedDiffusion(listediffusion_id);
    };

    const handleActiverDiffusion = async () => {
        if (selectedDiffusion) {
            try {
                const response = await fetch(process.env.REACT_APP_HOTE + `/activer-desactiver-liste-diffusion/${selectedDiffusion.id}/`, {
                    method: 'PUT',
                    headers: {
                        'Content-Type': 'application/json',
                    },
                });

                if (response.ok) {
                    const updatedDiffusion = await response.json();
                    setDiffusions(diffusions.map((listediffusion_id) =>
                        listediffusion_id.id === updatedDiffusion.id ? updatedDiffusion : listediffusion_id
                    ));
                    setSelectedDiffusion(updatedDiffusion);

                    // Stocker le message de succès dans localStorage
                    showAlert('Statut de la diffusion changé avec succès !');
                } else {
                    console.error('Erreur lors de la mise à jour du statut de la diffusion');
                }
            } catch (error) {
                console.error('Erreur réseau:', error);
            }
        }
    };

    const handleDeleteDiffusion = async () => {
        if (selectedDiffusion) {
            try {
                const response = await fetch(process.env.REACT_APP_HOTE + `/supprimer-liste-diffusion/${selectedDiffusion.id}/`, {
                    method: 'DELETE',
                });

                if (response.ok) {
                    setDiffusions(diffusions.filter((listediffusion_id) => listediffusion_id.id !== selectedDiffusion.id));
                    setSelectedDiffusion(null);

                    // Stocker le message de succès dans localStorage
                    showAlert('Diffusion supprimée avec succès !');
                } else {
                    console.error('Erreur lors de la suppression de la diffusion');
                }
            } catch (error) {
                console.error('Erreur réseau:', error);
            } finally {
                setShowDeleteModal(false);
            }
        }
    };

    const handleCloseModal = () => setShowModal(false);


    const handleAjouterUtilisateur = (listediffusion_id) => {
        if (listediffusion_id) {
            navigate(`/ajouter-utilisateur-diffusion`, {
                state: { listediffusion_id: listediffusion_id.id }, // Passage de l'ID par l'état
            });
        }
    };

    const filteredDiffusions = diffusions.filter(listediffusion_id =>
        listediffusion_id.nom.toLowerCase().includes(searchTerm.toLowerCase()) ||
        listediffusion_id.description.toLowerCase().includes(searchTerm.toLowerCase()) ||
        listediffusion_id.statut.toString().includes(searchTerm.toLowerCase()) ||
        listediffusion_id.ajoute_par.toString().includes(searchTerm.toLowerCase())
    );

    const sortedDiffusions = [...filteredDiffusions].sort((a, b) => {
        if (a[sortConfig.key] < b[sortConfig.key]) {
            return sortConfig.direction === 'ascending' ? -1 : 1;
        }
        if (a[sortConfig.key] > b[sortConfig.key]) {
            return sortConfig.direction === 'ascending' ? 1 : -1;
        }
        return 0;
    });


    const handleSort = (key) => {
        let direction = 'ascending';
        if (sortConfig.key === key && sortConfig.direction === 'ascending') {
            direction = 'descending';
        }
        setSortConfig({ key, direction });
    };

    const handleShowDeleteModal = () => {
        setShowDeleteModal(true);
    };

    const handleCloseDeleteModal = () => {
        setShowDeleteModal(false);
    };

    // Pagination logic
    const indexOfLastDiffusion = currentPage * itemsPerPage;
    const indexOfFirstDiffusion = indexOfLastDiffusion - itemsPerPage;
    const currentDiffusions = sortedDiffusions.slice(indexOfFirstDiffusion, indexOfLastDiffusion);
    const totalPages = Math.ceil(sortedDiffusions.length / itemsPerPage);

    // Gestion du changement d'éléments par page
    const handleItemsPerPageChange = (e) => {
        setItemsPerPage(Number(e.target.value));
        setCurrentPage(1); // Réinitialiser à la première page
    };

    const handleToggleDescription = (id) => {
        console.log("Toggling description for ID:", id); // Vérifiez l'identifiant
        setExpandedDescriptions((prev) => ({
            ...prev,
            [id]: !prev[id],
        }));
    };

    const checkDiffusionDescriptionOverflow = (diffusions) => {
        diffusions.forEach((listediffusion_id) => {
            const element = document.getElementById(`diffusion-description-${listediffusion_id.id}`);
            if (element) {
                setDiffusionDescriptionOverflows((prev) => ({
                    ...prev,
                    [listediffusion_id.id]: element.scrollHeight > element.clientHeight,
                }));
            }
        });
    };

    useEffect(() => {
        checkDiffusionDescriptionOverflow(diffusions);
    }, [diffusions]);


    const handleModifier = (listediffusion_id) => {
        if (listediffusion_id) {
            navigate(`/Modifier-diffusion`, {
                state: { listediffusion_id: listediffusion_id.id }, // Passage de l'ID par l'état
            });
        }
    };

    // Utiliser useEffect pour récupérer et afficher le message après redirection
    useEffect(() => {
        const successMessage = localStorage.getItem('successMessage');
        if (successMessage) {
            // Afficher le message (par exemple via une alerte ou un composant de notification)
            showAlert(successMessage);

            // Supprimer le message du localStorage après l'affichage
            localStorage.removeItem('successMessage');
        }
    }, []);

    const [accesGroupe, setAccesGroupe] = useState([]);
    const [groupeId, setGroupeId] = useState(null);
    const groupe = localStorage.getItem('groupe');

    const verifGroupe = async () => {
        const groupeStored = localStorage.getItem('groupe');
        const accesGroupeStored = localStorage.getItem('accesGroupe');

        if (groupeStored && accesGroupeStored) {
            setGroupeId(groupeStored);
            setAccesGroupe(JSON.parse(accesGroupeStored));
        } else {
            try {
                const response = await axios.get(`${process.env.REACT_APP_HOTE}/verif-groupe/${user_id}/${groupe}`);
                if (response.status === 200) {
                    const data = response.data;
                    setGroupeId(data.groupe);

                    let cleanedAccessArray = [];
                    if (Array.isArray(data.acces)) {
                        cleanedAccessArray = data.acces.map((item) =>
                            item.acces
                                ? item.acces.replace(/[\[\]']/g, '').trim().split(',').map((access) => access.trim())
                                : []
                        ).flat();

                        setAccesGroupe(cleanedAccessArray);
                    }

                    localStorage.setItem('groupe', data.groupe);
                    localStorage.setItem('accesGroupe', JSON.stringify(cleanedAccessArray));
                }
            } catch (error) {
                // console.error('Erreur lors de la vérification du groupe', error);
            }
        }
    };

    useEffect(() => {
        if (user_id) {
            verifGroupe();
        }
    }, [user_id]);

    if (!accesGroupe.includes("ListeDeDiffusion")) {
        return (
            <div id="wrapper">
                <Sidebar user_id={user_id} titre={titre} />
                <div id="page-wrapper" className="gray-bg">
                    <Navbar />
                    <div className="wrapper wrapper-content animated fadeInRight">
                        <div className="row">
                            <div className="col-lg-12">
                                <div className="ibox">
                                    <div className="ibox-content text-center p-5">
                                        <div className="mb-4">
                                            <i className="fa fa-lock fa-5x text-warning"></i>
                                        </div>
                                        <h2>Accès restreint</h2>
                                        <p className="lead mb-4">
                                            Vous n'avez pas les autorisations nécessaires pour accéder à cette page.
                                        </p>
                                        <div className="d-flex justify-content-center">
                                                                                    <Link to="/" className="btn btn-primary">
                                                                                        <i className="fa fa-arrow-left mr-2"></i>
                                                                                        Retour
                                                                                    </Link>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        );
    }


    return (
        <div id="wrapper">
            <Sidebar user_id={user_id} titre={titre} />
            <div id="page-wrapper" className="gray-bg">
                <Navbar />
                <div>
                    <div className="row wrapper border-bottom white-bg page-heading">
                        <div className="col-lg-12">
                            <h2 className="mb-1"><i className="fa fa-rss"></i> Gestion des diffusions</h2>
                            <small>Administration des listes de diffusions.</small>

                            <small id='hbreadcrumb' className='d-flex justify-content-end'>
                                <ol className="breadcrumb custom-breadcrumb">
                                    <li className="breadcrumb-item custom-breadcrumb-item">
                                        {/* Utiliser Link de react-router-dom pour la navigation */}
                                        <Link to={`/admin`}> Administration</Link>
                                    </li>
                                    <li className="breadcrumb-item custom-breadcrumb-item">
                                        {/* Utiliser Link de react-router-dom pour la navigation */}
                                        <Link to={`/Liste-diffusion`}> Liste de diffusions</Link>
                                    </li>
                                </ol>
                            </small>
                        </div>
                    </div>
                    {/* <Header titre="Groupes" sous_titre="Dashboard" sous_titre1={<Link to={`/admin`} className='text-dark'>Administration</Link>} entete="Groupes"  user_id={user_id}/> */}
                    <div className="mt-3">
                        <div className="wrapper wrapper-content animated fadeInRight">
                            <div className="d-flex flex-column flex-md-row justify-content-between align-items-center mb-3">
                                <h5>Liste des diffusions</h5>
                                <div className="d-flex flex-column flex-md-row mt-3 mt-md-0">

                                    <div className="d-flex">
                                        <Link to={`/Ajouter-diffusion`} className="btn btn-success mr-2 ms-0 mb-2 mb-md-0 ms-md-2">
                                            <FaPlus /> Créer une diffusion
                                        </Link>
                                        <button
                                            onClick={() => handleModifier(selectedDiffusion)}
                                            className={`btn mr-2 mb-2 mb-md-0 ms-0 ms-md-2 ${selectedDiffusion ? 'btn-success' : 'btn-default text-dark'}`}
                                            disabled={!selectedDiffusion}
                                        >
                                            <FaEdit /> Modifier
                                        </button>
                                    </div>
                                    <div className="d-flex">
                                        <button
                                            onClick={handleActiverDiffusion}
                                            className={`btn mr-2 mb-2 mb-md-0 ms-0 ms-md-2 ${selectedDiffusion ? 'btn-success' : 'btn-default text-dark'}`}
                                            disabled={!selectedDiffusion}
                                        >
                                            <FaCheck /> Activer / Désactiver
                                        </button>
                                        <button
                                            onClick={handleShowDeleteModal}
                                            className={`btn mr-2 mb-2 mb-md-0 ms-0 ms-md-2 ${selectedDiffusion ? 'btn-success' : 'btn-default text-dark'}`}
                                            disabled={!selectedDiffusion}
                                        >
                                            <FaTrash /> Supprimer
                                        </button>

                                    </div>
                                    <div className="d-flex">
                                        <button
                                            onClick={() => handleAjouterUtilisateur(selectedDiffusion)}
                                            className={`btn mr-2 mb-2 mb-md-0 ms-0 ms-md-2 ${selectedDiffusion ? 'btn-success' : 'btn-default text-dark'}`}
                                            disabled={!selectedDiffusion || (selectedDiffusion.statut === "inactif")}
                                        >
                                            <i className="fa fa-users" aria-hidden="true"></i> Utilisateurs
                                        </button>
                                    </div>

                                </div>
                            </div>

                            {alert.message && (
                                <div className={`alert alert-${alert.type}`}>
                                    {alert.message}
                                </div>
                            )}

                            <div className="row">
                                <div className="col-lg-12">
                                    <div className="ibox">

                                        <div className="ibox-content">
                                            <div className="d-flex justify-content-between align-items-center mb-3">
                                                <div className="me-2">
                                                    <select
                                                        value={itemsPerPage}
                                                        onChange={handleItemsPerPageChange}
                                                        className="form-select bg-default p-1"
                                                        style={{ width: 'auto', border: '1px black solid', borderRadius: '5px' }}
                                                    >
                                                        <option value={10}>10</option>
                                                        <option value={20}>20</option>
                                                        <option value={50}>50</option>
                                                    </select>
                                                </div>
                                                <input
                                                    type="text"
                                                    placeholder="Rechercher..."
                                                    className="form-control"
                                                    style={{ maxWidth: '150px', width: '100%' }} // Largeur fixe ou maximale selon besoin
                                                    value={searchTerm}
                                                    onChange={(e) => setSearchTerm(e.target.value)}
                                                />
                                            </div>
                                            <div className="table-responsive" style={{ fontSize: '11px' }}>
                                                <table className="footable table table-stripped footable-loaded tablet breakpoint" data-page-size="8" data-filter="#filter">
                                                    <thead>
                                                        <tr>
                                                            <th style={{ width: '15%' }} className='text-secondary text-wrap d-none d-md-table-cell' onClick={() => handleSort('nom')}>Nom{sortConfig.key === 'nom'}{sortConfig.direction === 'ascending' ? <FaSortAmountUp /> : <FaSortAmountDown />}</th>
                                                            <th style={{ width: '45%' }} className='text-secondary text-wrap d-none d-md-table-cell' onClick={() => handleSort('description')}>Description {sortConfig.key === 'description'}{sortConfig.direction === 'ascending' ? <FaSortAmountUp /> : <FaSortAmountDown />}</th>
                                                            <th style={{ width: '10%' }} className='text-secondary text-wrap d-none d-md-table-cell' onClick={() => handleSort('statut')}>Statut {sortConfig.key === 'statut'}{sortConfig.direction === 'ascending' ? <FaSortAmountUp /> : <FaSortAmountDown />}</th>
                                                        </tr>
                                                    </thead>
                                                    <tbody>
                                                        {currentDiffusions.length > 0 ? currentDiffusions.map((listediffusion_id) => {
                                                            const isExpanded = expandedDescriptions[listediffusion_id.id];
                                                            return (
                                                                <tr
                                                                    key={listediffusion_id.id}
                                                                    onClick={() => handleRowClick(listediffusion_id)}
                                                                    className={`bg-white ${selectedDiffusion && selectedDiffusion.id === listediffusion_id.id ? 'bg-success text-white' : ''}`}
                                                                >
                                                                    <td>
                                                                        {listediffusion_id.nom}
                                                                        <div className='lesInfos'>
                                                                            <small>Description :
                                                                                <div
                                                                                    id={`diffusion-description-${listediffusion_id.id}`}
                                                                                    className={`description-text ${expandedDescriptions[listediffusion_id.id] ? 'expanded' : ''}`}
                                                                                    style={{ maxHeight: expandedDescriptions[listediffusion_id.id] ? 'none' : '3em', overflow: 'hidden', whiteSpace: 'pre-wrap' }}
                                                                                >
                                                                                    {listediffusion_id.description ? (
                                                                                        // Utilisation de dangerouslySetInnerHTML pour afficher le contenu HTML
                                                                                        <span dangerouslySetInnerHTML={{ __html: listediffusion_id.description }}></span>
                                                                                    ) : (
                                                                                        <em>Non défini</em> // Affichage en italique si la description n'est pas définie
                                                                                    )}
                                                                                </div>
                                                                                {listediffusion_id.description && diffusionDescriptionOverflows[listediffusion_id.id] && (
                                                                                    <button
                                                                                        onClick={() => handleToggleDescription(listediffusion_id.id)}
                                                                                        style={{ background: 'none', border: 'none', color: 'black', cursor: 'pointer', padding: 0 }}
                                                                                    >
                                                                                        {expandedDescriptions[listediffusion_id.id] ? 'Voir moins' : 'Voir plus...'}
                                                                                    </button>
                                                                                )}
                                                                            </small>
                                                                            <small>Statut : {listediffusion_id.statut}</small>
                                                                        </div>
                                                                    </td>

                                                                    <td className="d-none d-md-table-cell">{listediffusion_id.description}</td>
                                                                    <td className="d-none d-md-table-cell">{listediffusion_id.statut}</td>
                                                                </tr>
                                                            );
                                                        }) : (
                                                            <tr>
                                                                <td colSpan="5">Aucune notification à afficher</td>
                                                            </tr>
                                                        )}

                                                    </tbody>
                                                </table>
                                            </div>

                                            {/* Pagination Controls */}
                                            <div className="d-flex justify-content-between align-items-center mt-3">
                                                <div className="dataTables_info" role="status" aria-live="polite">
                                                    {totalItems === 0
                                                        ? "Aucun élément à afficher"
                                                        : `Élément ${indexOfFirstDiffusion + 1} à ${Math.min(indexOfLastDiffusion, totalItems)} sur ${totalItems}`}
                                                </div>
                                                <div>
                                                    <button
                                                        onClick={() => setCurrentPage(currentPage > 1 ? currentPage - 1 : 1)}
                                                        className="btn btn-light mx-1"
                                                        disabled={currentPage === 1}
                                                    >
                                                        <FaArrowLeft />
                                                    </button>

                                                    {(() => {
                                                        const pagesToShow = 5; // Nombre total de pages à afficher
                                                        let startPage = Math.max(1, currentPage - Math.floor(pagesToShow / 2));
                                                        let endPage = Math.min(totalPages, startPage + pagesToShow - 1);

                                                        // Ajuster le startPage si la fin dépasse le total des pages
                                                        if (endPage - startPage < pagesToShow - 1) {
                                                            startPage = Math.max(1, endPage - pagesToShow + 1);
                                                        }

                                                        const pageButtons = [];

                                                        // Ajout des boutons de pages
                                                        for (let i = startPage; i <= endPage; i++) {
                                                            pageButtons.push(
                                                                <button
                                                                    key={i}
                                                                    onClick={() => setCurrentPage(i)}
                                                                    className={`btn ${currentPage === i ? 'btn-default' : 'btn-light'} mx-1`}
                                                                >
                                                                    {i}
                                                                </button>
                                                            );
                                                        }

                                                        return pageButtons;
                                                    })()}

                                                    <button
                                                        onClick={() => setCurrentPage(currentPage < totalPages ? currentPage + 1 : totalPages)}
                                                        className="btn btn-light mx-1"
                                                        disabled={currentPage === totalPages}
                                                    >
                                                        <FaArrowRight />
                                                    </button>

                                                    {/* Bouton pour aller à la dernière page */}
                                                    <button
                                                        onClick={() => setCurrentPage(totalPages)}
                                                        className="btn btn-light mx-1"
                                                        disabled={currentPage === totalPages}
                                                    >
                                                        {totalPages}
                                                    </button>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>


                    {/* Modal de confirmation de suppression */}
                    <Modal show={showDeleteModal} onHide={handleCloseDeleteModal}>
                        <Modal.Header>
                            <Modal.Title>Confirmer la Suppression</Modal.Title>
                        </Modal.Header>
                        <Modal.Body>
                            Êtes-vous sûr de vouloir supprimer la liste de diffusion <strong>{selectedDiffusion?.nom}</strong> ?
                        </Modal.Body>
                        <Modal.Footer>
                            <Button variant="secondary" onClick={handleCloseDeleteModal}>
                                Annuler
                            </Button>
                            <Button variant="success" onClick={handleDeleteDiffusion}>
                                Supprimer
                            </Button>
                        </Modal.Footer>
                    </Modal>

                </div>
            </div>

            {/* Styles CSS pour les cellules fixes */}
            <style jsx>{`
    width: 300px; /* Ajustez cette valeur selon vos besoins */
    overflow: hidden; /* Évite le débordement de contenu */
    text-overflow: ellipsis; /* Ajoute des "..." pour le contenu tronqué si nécessaire */
    word-wrap: break-word; /* Permet au texte de s'enrouler et de casser les mots longs */
    overflow-wrap: break-word; /* Ajoute cette propriété pour la compatibilité */
    white-space: normal; /* Permet le retour à la ligne */
`}</style>
        </div>
    );
};

export default Liste_diffusion;
